import { Globe } from 'lucide-react';
import { ANY_GEO, flagUrl, geoName, parseStoredGeo } from '../lib/geo';

/** A single geo: flag + code, or a globe for "Any geo". */
export function GeoChip({ code, showCode = true }: { code: string; showCode?: boolean }) {
  if (code === ANY_GEO) {
    return (
      <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium bg-slate-100 text-slate-600" title="Any geo — not targeted at specific countries">
        <Globe className="h-3 w-3" /> Any
      </span>
    );
  }
  const url = flagUrl(code);
  return (
    <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium bg-blue-50 text-blue-700" title={geoName(code)}>
      {url
        ? <img src={url} alt="" loading="lazy" className="h-3 w-4 rounded-[2px] object-cover shadow-[0_0_0_0.5px_rgba(0,0,0,0.15)]" />
        : <Globe className="h-3 w-3 text-blue-400" />}
      {showCode && code}
    </span>
  );
}

/** A geo list as chips; collapses past `max` into "+N". */
export function GeoList({ value, max = 4 }: { value: string | string[] | null | undefined; max?: number }) {
  const codes = parseStoredGeo(value);
  if (codes.length === 0) return <span className="text-slate-400">-</span>;
  const shown = codes.slice(0, max);
  const hidden = codes.slice(max);
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      {shown.map((c) => <GeoChip key={c} code={c} />)}
      {hidden.length > 0 && (
        <span className="text-xs text-slate-500" title={hidden.map(geoName).join(', ')}>+{hidden.length}</span>
      )}
    </span>
  );
}
